<template>
  <div class="bo_nav_headline" :class="{'loggedInUser': isLoggedIn}">
    <template v-if="!inHeader">
      <div class="sb_title">
        <icon v-if="currentBoNavigation && currentBoNavigation.imageicon" :name="currentBoNavigation.imageicon"></icon>
        <h1>{{(currentBoNavigation && currentBoNavigation.name) || title}}</h1>
      </div>
      <h3>{{currentBoNavigation && (currentBoNavigation.description || currentBoNavigation.internaldescription)}}</h3>
    </template>
    <template v-if="inHeader">
      <div v-if="mobileBigAndBelow && isParlayZone === $t('Parlay.Zone.Title')" class="pp_header">
        <div class="header-title">
          <span class="pp_icon"></span>
          <h1 v-html="$t('Parlay.Zone.Title')"></h1>
        </div>
      </div>
      <div v-if="mobileBigAndBelow && isBetZone === $t('Bet.Zone.Title')" class="pp_header">
        <div class="header-title">
          <span class="betzone_icon"></span>
          <h1 v-html="$t('Bet.Zone.Title')"></h1>
        </div>
      </div>
      <div class="fast_switch_title" v-if="isFastSwitchEnabled && (idFwMarketgroup || liveEvent)" @click="toggleFastSwitch"><h1><icon v-if="liveEvent" name="icon-live"></icon>{{ event && event.fosportname || event && event.sportname }}</h1><span class="arrow_down"><v-icon>keyboard_arrow_down</v-icon></span></div>
      <h1 :class="{'title-live': pageTitle === 'live'}" v-if="!(currentBoNavigation && currentBoNavigation.name) && pageTitle && $te('PageTitle.' + pageTitle)">{{ $t('PageTitle.' + pageTitle)}} <icon v-if="pageTitle === 'live'" name="icon-live"></icon></h1>
      <h1 class="title-live" v-if="!isFastSwitchEnabled && liveEvent">{{ $t('PageTitle.live')}} <icon name="icon-live"></icon></h1>
    </template>
  </div>
</template>
<script>
  import store from '@/store'
  import config from '@/config'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import Icon from '@/components/common/Icon'
  import Screen from '@/components/mixins/Screen'

  export default {
    name: 'SportsBreadcrumb',
    data () {
      return {
        parlayZoneTitleText: 'Parlay.Zone.Title'
      }
    },

    props: [
      'title',
      'inHeader'
    ],

    components: {
      Icon
    },

    mixins: [
      BettingOffer,
      Screen
    ],

    computed: {
      bonavigation1 () {
        return (this.idfwbonavigation1 && this.boNavigation && this.boNavigation[this.idfwbonavigation1]) || undefined
      },
      bonavigation2 () {
        return (this.idfwbonavigation2 && this.boNavigation && this.boNavigation[this.idfwbonavigation2]) || undefined
      },
      currentBoNavigation () {
        if (this.bonavigation1 && this.bonavigation1.idfwbonavigationtypes && this.bonavigation1.idfwbonavigationtypes.filter(bonavtype => bonavtype === 'MAIN').length > 0) {
          return this.bonavigation1 || undefined
        } else {
          return this.bonavigation2 || undefined
        }
      },
      idfoevent () {
        return this.$route.params.idfoevent
      },
      event () {
        return store.getters['eventState/getEvent']
      },
      liveEvent () {
        var self = this
        if (this.idfoevent && this.liveEvents && this.liveEvents.length > 0) {
          return this.liveEvents.find(ev => ev.idfoevent.toString() === self.idfoevent.toString() || (ev.foeventantepost && ev.foeventantepost.toString() === self.idfoevent.toString()))
        }
      },
      pageTitle () {
        if (this.$route.name === 'searchsport' || this.$route.name === 'searchcompetition') {
          return 'search'
        }
        if ((this.$route.path.indexOf('/sports/event/') > -1)) {
          return ''
        } if (this.$route.name === 'history-state') {
          return 'mybets'
        } else {
          return this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1)
        }
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      isPopularParlaysEnabled () {
        return config.app.autoconf.PLAYER_PERSONALISATION.enablePopularParlays
      },
      isParlayZone () {
        return this.isPopularParlaysEnabled && this.$route.name === 'parlayzone' ? this.$t(this.parlayZoneTitleText) : ((this.currentBoNavigation && this.currentBoNavigation.name) || this.title)
      },
      isFastSwitchEnabled () {
        return config.app.autoconf.FAST_SWITCH
      },
      fastSwitchDialog () {
        return store.getters['overlayState/getFastSwitchDialog']
      },
      idFwMarketgroup () {
        return this.$route.query.idfwmarketgroup
      },
      isBetZone () {
        return this.$route.name === 'betzone' ? this.$t('Bet.Zone.Title') : ((this.currentBoNavigation && this.currentBoNavigation.name) || this.title)
      }
    },
    methods: {
      toggleFastSwitch () {
        if (this.fastSwitchDialog) {
          store.dispatch('overlayState/deactivateFastSwitchDialog')
        } else {
          store.dispatch('overlayState/activateFastSwitchDialog')
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import "~@/css/config";
.header
  .bo_nav_headline
    text-align: left
    &.loggedInUser
      margin-left 40px
.bo_nav_headline
  .title-live
    >>>.font-icon
      color #e7212d
      padding-left 10px
      font-size 27px
    >>>.igt-icon > span
      height 27px
      width 27px

  h1
    font-weight: bold
    font-size: 76px
    line-height: 76px
    color: white
    text-transform: uppercase
    text-align: left
  h3
    font-size: 18px
    text-align: left
    color:white
    font-weight: 600
    max-height: 35px
    overflow: hidden
    line-height: 21px
    opacity: 0.8

@media mobile-big-and-below
  h1
    font-size: 26px !important
    line-height: 30px !important
  h3
    font-size: 15px !important
.bo_nav_headline
  .pp_header
    .header-title
      display flex
      align-items center
      .pp_icon
        background var(--poular-menu-popularparlays-icon) 100% center no-repeat
        width 27px
        height 22px
        display inline-flex
        margin-right 10px
      .betzone_icon
        background var(--poular-menu-betzone-icon) 100% center no-repeat
        width 27px
        height 22px
        display inline-flex
        margin-right 10px

.fast_switch_title
  display flex
  align-items: center
  h1
    text-transform: uppercase !important
  .arrow_down
    display inline-flex
    margin-left 2px
    .v-icon
      color var(--coupon-text-color)
      font-size 30px
      @media mobile-big-and-below
        color var(--header-text-color-mobile) !important
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/sportsBreadcrumb.vue